export const isBroadcastMessage = message => 'group' in message;